import { useEffect, useState } from 'react';
import type { Meal } from '../../shared/dates';
import { OPEN_MEALS_KEY, readOpenMeals, toggleMeal, writeOpenMeals } from './openMeals';

/**
 * Which meals on Today show their full nutrition, remembered on this device. Saved when a
 * meal is toggled (not on load), and kept in step when another tab changes it.
 */
export function useOpenMeals(): [ReadonlySet<Meal>, (meal: Meal) => void] {
  const [open, setOpen] = useState<ReadonlySet<Meal>>(() => new Set(readOpenMeals()));

  useEffect(() => {
    const sync = (e: StorageEvent) => {
      // A null key means another tab cleared storage.
      if (e.key === OPEN_MEALS_KEY || e.key === null) setOpen(new Set(readOpenMeals()));
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  // From this render's set: React re-renders between separate taps, so each toggle sees the last one.
  const toggle = (meal: Meal) => {
    const next = toggleMeal(open, meal);
    setOpen(next);
    writeOpenMeals(next);
  };
  return [open, toggle];
}
